module.exports = __webpack_public_path__ + "static/media/home-bg-2.9fb59538.jpg";